import { SplitEvaluationSchemaType } from 'domains/signupDirect/schemas/evaluationScheduleSchema';
import { createContext } from 'react';

type SplitEvaluationContextType = {
  onSubmitFirstSlot: (timeSlot: SplitEvaluationSchemaType['firstTimeSlot']) => void;
  onSubmitSecondSlot: (timeSlot: SplitEvaluationSchemaType['secondTimeSlot']) => void;
  onSkipSecondSlot: () => void;

  firstTimeSlot?: SplitEvaluationSchemaType['firstTimeSlot'];
};

export const SplitEvaluationContext = createContext<null | SplitEvaluationContextType>(null);
